import React from "react";
import OpenPDFButton from "./OpenPDFButton";

const quotes = [
  {
    text:
      "BizMak helped us to re-design and re-develop our application entirely. They did such a good job with their expert opinion that solves our internal application act smoothly. We were so happy with them that they are working on our another application.",
    name: "Lori J.",
    org: "ADT",
  },
  {
    text:
      "We was looking for Enterprise solution for our application with through testing. Bizmak actually helped us to achieve bug free application. Not to mention but their testing team is remarkable.",
    name: "Sandeep P.",
    org: "CGI Federal",
  },
  {
    text:
      "Bizmak's employment solution is tremendous. They helped us to subcontract couple of their employees. But they assign one of their manager to overlook the entire progress of subcontracting.",
    name: "Scott D.",
    org: "Judge Group",
  },
  {
    text:
      "Their ecommerce solution is great and they give our savvy look website a great look. And then give us the Marketting solutions which is giving us a lot of sales every month.",
    name: "Sheila A.",
    org: "PetFondles.com",
  },
  {
    text:
      "Our Business is getting lot of Sales due to their Digital Marketting Strategy. I Believe we was their First client but how they worked with us, They spend a lot of time to make our business success.",
    name: "Eric P.",
    org: "HeartStorez.com",
  },
];

function Portfolio() {
  return (
    <section
      className="bizmak-section bizmak-section-dark page-section mb-0"
      id="portfolio"
    >
      <div className="container">
        <h2 className="page-section-heading text-center text-white mb-0">
          Client outcomes
        </h2>
        <p className="section-intro">
          Real feedback from teams we have shipped with — from enterprise
          modernization to commerce and federal-adjacent programs.
        </p>
        <div className="divider-custom divider-light">
          <div className="divider-custom-line" />
          <div className="divider-custom-icon">
            <i className="fas fa-star" aria-hidden="true" />
          </div>
          <div className="divider-custom-line" />
        </div>

        <div className="row g-4">
          {quotes.map((q) => (
            <div key={q.org} className="col-md-6 col-xl-4">
              <div className="bizmak-quote-card">
                <div className="quote-mark" aria-hidden="true">
                  <i className="fas fa-quote-left" />
                </div>
                <blockquote>{q.text}</blockquote>
                <cite>{q.name}</cite>
                <span className="org">{q.org}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 pt-3">
          <OpenPDFButton variant="light" />
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
